import { faqItems } from '@/mocks/homeData';

export default function Faq() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              关于911吃瓜网，你想知道的都在这里
            </p>
          </div>

          <div className="space-y-3">
            {faqItems.map((item, idx) => (
              <div
                key={idx}
                className="bg-background-50 rounded-xl p-5 md:p-6"
              >
                <div className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-sm font-bold mt-0.5">
                    Q
                  </span>
                  <div>
                    <h3 className="font-heading text-base md:text-lg text-foreground-800 mb-2">
                      {item.q}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}